import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ProjectButton from '../../../components/ProjectButton/ProjectButton';
import { getSafe } from '../../../shared/utility';
import './ProjectsSelection.scss';
import {
  PROJECT_SELECTION_MAIN_PROJECTS,
  PROJECT_SELECTION_SUB_PROJECTS,
} from '../../../shared/const/Routes/statePaths';
import {
  getMainProjects,
  getSubProjects,
} from '../../../store/actions/jobConfiguration/jobConfiguration';
import SubProjectButton from '../../../components/SubProjectButton/SubProjectButton';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';

const ProjectsSelection = props => {
  const {
    selectedProject,
    setSelectedProject,
    selectedSubProject,
    setSelectedSubProject,
  } = props;
  const dispatch = useDispatch();
  const allProjects = useSelector(state =>
    getSafe(PROJECT_SELECTION_MAIN_PROJECTS, state)
  );
  const subProjects = useSelector(state =>
    getSafe(PROJECT_SELECTION_SUB_PROJECTS, state)
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    //dispatch action to get all projects
    if (selectedSubProject) {
      props.setNextDisabled(false);
    }
    if (!allProjects) {
      setIsLoading(true);
      dispatch(getMainProjects());
    }
  }, []);

  useEffect(() => {
    if (allProjects) {
      setIsLoading(false);
    }
  }, [allProjects]);

  useEffect(() => {
    if (subProjects) {
      setIsLoading(false);
    }
  }, [subProjects]);

  const onSubProjectSelected = subProject => {
    setSelectedSubProject(subProject);
    props.setNextDisabled(false);
  };

  const getSubProjectsLines = () => {
    //return mapping of all sub projects - ProjectButton component - passed this method onSubProjectSelected to the component
    let subProjectsButtons = subProjects?.map(subProject => {
      return (
        <SubProjectButton
          key={subProject?.projectId}
          onClick={onSubProjectSelected}
          project={subProject}
          isProjectDisabled={false}
          selectedProject={selectedSubProject}
        />
      );
    });
    return subProjectsButtons;
  };

  const onParentProjectSelected = projectName => {
    if (projectName == selectedProject) {
      return;
    }
    setIsLoading(true);
    props.setNextDisabled(true);
    setSelectedProject(projectName);
    setSelectedSubProject(null);
    dispatch(getSubProjects(projectName));
  };

  const getProjectsColumn = () => {
    //return mapping of all parent projects - Button component - passed this method onParentProjectSelected to the component
    let projectButtons = allProjects.map(projectName => {
      return (
        <ProjectButton
          key={projectName}
          onClick={onParentProjectSelected}
          projectName={projectName}
          isProjectDisabled={false}
          selectedProject={selectedProject}
        />
      );
    });
    return projectButtons;
  };

  return (
    <div className={props.className}                 style={{'display': 'grid', 'height': '100%'}}
>
      <LoadingOverlay loading={isLoading}>
        <div className="project-selection-wrapper">
          <div className="all-buttons-wrapper">
            <div className="project-buttons-wrapper">
              {allProjects ? (
                <div className="flex-column">
                  <div className="projectButtons">{getProjectsColumn()}</div>
                </div>
              ) : null}
            </div>
            {selectedProject ? (
              <div className="sub-project-buttons-wrapper">
                <div className="project-sub-title">{selectedProject}</div>
                <div className="sub-project-button-container">
                  {getSubProjectsLines()}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default React.memo(ProjectsSelection);
